/* 🤖 this file was generated by svg-to-ts */
export const iccIconWarning: {
  name: 'warning';
  data: string;
} = {
  name: 'warning',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12 6.49 7.53 13.01H4.47L12 6.49Zm0-3.99-11 19h22l-11-19Zm1 14h-2v2h2v-2Zm0-6h-2v4h2v-4Z" fill="currentColor"/></svg>`
};
